// pages/Particulares.js
import React, { useState, useEffect, useRef } from 'react';
import {
  Table,Alert,
  Button,
  Modal,
  Form,
  Input,
  Switch,
  InputNumber,
  Select,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Popconfirm,
  Badge,
  Statistic,Spin ,
  DatePicker,Input as AntInput
} from 'antd';
import {
  PlusOutlined,KeyOutlined ,
  EditOutlined,
  DeleteOutlined,
  BlockOutlined,
  UnlockOutlined,
  SearchOutlined,
  UserOutlined,
  ExportOutlined,
  MailOutlined,
  PhoneOutlined,
  IdcardOutlined,ReloadOutlined
} from '@ant-design/icons';
import axios from 'axios';
import dayjs from 'dayjs';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;

const Particulares = () => {

  const renderFlag = (codigoISO) => {
    if (!codigoISO || codigoISO.trim() === '') {
      return <span style={{ marginRight: '8px' }}>🌍</span>;
    }
    return <span className={`fi fi-${codigoISO.toLowerCase()}`} style={{ marginRight: '8px' }} />;
  };
  
  
  // Estados
  const [particulares, setParticulares] = useState([]);
  const [paises, setPaises] = useState([]);

  const [proximoCodigo, setProximoCodigo] = useState('');
  const [loadingCodigo, setLoadingCodigo] = useState(false);  
  
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalType, setModalType] = useState('create');
  const [currentParticular, setCurrentParticular] = useState(null);
  const [form] = Form.useForm();
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);

  const [tiposClientes, setTiposClientes] = useState([]);
  const [loadingTipos, setLoadingTipos] = useState(false);  

  const [pagination, setPagination] = useState({
      current: 1,
      pageSize: 50,
      total: 0,
      showSizeChanger: true,
      showQuickJumper: true,
      showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
    });  
  
  // Estados para filtros y ordenación
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  const [searchText, setSearchText] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);

  // Configuración de columnas de la tabla
  const columns = [
    {
      title: 'Código',
      dataIndex: 'Codigo',
      key: 'Codigo',
      sorter: (a, b) => a.Codigo.localeCompare(b.Codigo),
      sortOrder: sortedInfo.columnKey === 'Codigo' && sortedInfo.order,
      width: 100,
    },
    {
      title: 'Nombre Completo',
      dataIndex: 'Nombre',
      key: 'Nombre',
      sorter: (a, b) => {
            //a.Nombre.localeCompare(b.Nombre)
            const aVal = a.Nombre || '';
            const bVal = b.Nombre || '';
            return aVal.localeCompare(bVal)
      },
          
      sortOrder: sortedInfo.columnKey === 'Nombre' && sortedInfo.order,
      ellipsis: true,
      width: 200,
      render: (nombre, record) => {
        // Manejar valores nulos
        const nombreCompleto = nombre || '';
        const nombre1 = record.nombre1 || '';
        const apellido1 = record.apellido1 || '';
        const apellido2 = record.apellido2 || '';
        
        const tieneDetalles = nombre1 || apellido1 || apellido2;
        
        return (
          <div>
            <div>{nombreCompleto || 'Sin nombre'}</div>
            {tieneDetalles && (
              <div style={{ fontSize: '12px', color: '#666' }}>
                {nombre1} {apellido1} {apellido2}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: 'Documento',
      dataIndex: 'NIF',
      key: 'NIF',
      width: 140,
      render: (nif, record) => {
        const tipoDoc = record.TipoDocumento || 'No especificado';
        const tieneNif = nif && nif.trim() !== '';
        
        if (tieneNif) {
          return (
            <Tooltip title={`Tipo: ${tipoDoc}`}>
              <Tag icon={<IdcardOutlined />} color="blue">
                {nif}
              </Tag>
            </Tooltip>
          );
        }
        return (
          <Tooltip title="Sin documento">
            <Tag color="default">Sin NIF</Tag>
          </Tooltip>
        );
      },
    },
    {
      title: 'Teléfono',
      dataIndex: 'Telefono1',
      key: 'Telefono1',
      width: 140,
      render: (telefono) => {
        if (telefono && telefono.trim() !== '') {
          return (
            <div>
              <PhoneOutlined style={{ marginRight: 4 }} />
              {telefono}
            </div>
          );
        }
        return <span style={{ color: '#999' }}>Sin teléfono</span>;
      },
    },
    {
      title: 'Email',
      dataIndex: 'EMail',
      key: 'EMail',
      width: 180,
      render: (email) => {
        if (email && email.trim() !== '') {
          return (
            <Tooltip title={email}>
              <div style={{ 
                whiteSpace: 'nowrap', 
                overflow: 'hidden', 
                textOverflow: 'ellipsis',
                color: '#1890ff' 
              }}>
                <MailOutlined style={{ marginRight: 4 }} />
                {email}
              </div>
            </Tooltip>
          );
        }
        return <span style={{ color: '#999' }}>Sin email</span>;
      },
    },
    {
      title: 'Localización',
      key: 'localizacion',
      width: 180,
      render: (_, record) => {
        const poblacion = record.Poblacion || '';
        const provincia = record.Provincia || '';
        const pais = record.Pais || '';
        
        const tieneLocalizacion = poblacion || provincia || pais;
        
        if (tieneLocalizacion) {
          return (
            <div>
              {poblacion && <div>{poblacion}</div>}
              {provincia && <div style={{ fontSize: '12px', color: '#666' }}>{provincia}</div>}
              {pais && <div style={{ fontSize: '12px', color: '#999' }}>{pais}</div>}
            </div>
          );
        }
        return <span style={{ color: '#999' }}>Sin localización</span>;
      },
    },
    {
      title: 'Tipo Cliente',
      dataIndex: 'TipoCliente',
      key: 'TipoCliente',
      width: 120,
      render: (codigoTipo, record) => {
        // Si no hay código de tipo, mostrar "Particular"
        if (!codigoTipo || codigoTipo.trim() === '') {
          return <Tag color="default">Particular</Tag>;
        }
        
        const descripcion = getDescripcionTipoCliente(codigoTipo);
        const color = getColorTipoCliente(codigoTipo);
        
        return (
          <Tooltip title={`Código: ${codigoTipo}`}>
            <Tag color={color}>
              {descripcion}
            </Tag>
          </Tooltip>
        );
      },
      filters: [
        // Primero los tipos específicos
        { text: 'PARTICULARS', value: '2' },
        { text: 'AGENCIA', value: '1' },
        { text: 'ESTUD.-DEPORT.', value: '3' },
        // Luego otros posibles valores
        { text: 'VIP', value: 'VIP' },
        { text: 'GRU', value: 'GRU' },
        // Finalmente particulares sin tipo
        { text: 'Particular', value: '' },
      ],
      filteredValue: filteredInfo.TipoCliente || null,
      onFilter: (value, record) => {
        const recordTipo = record.TipoCliente || '';
        if (value === '') {
          return !recordTipo || recordTipo.trim() === '';
        }
        return recordTipo === value;
      },
    },
    {
      title: 'Estado',
      dataIndex: 'bloqueado',
      key: 'bloqueado',
      render: (bloqueado, record) => (
        <Badge
          status={bloqueado ? 'error' : 'success'}
          text={bloqueado ? 'Bloqueado' : 'Activo'}
        />
      ),
      width: 100,
      filters: [
        { text: 'Activos', value: false },
        { text: 'Bloqueados', value: true },
      ],
      filteredValue: filteredInfo.bloqueado || null,
      onFilter: (value, record) => record.bloqueado === value,
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 180,
      render: (_, record) => (
        <Space>
          <Tooltip title="Editar">
            <Button
              type="primary"
              icon={<EditOutlined />}
              size="small"
              onClick={() => handleEdit(record)}
            />
          </Tooltip>
          
          <Tooltip title={record.bloqueado ? "Desbloquear" : "Bloquear"}>
            <Button
              type={record.bloqueado ? "primary" : "dashed"}
              danger={!record.bloqueado}
              icon={record.bloqueado ? <UnlockOutlined /> : <BlockOutlined />}
              size="small"
              onClick={() => handleToggleBlock(record)}
            />
          </Tooltip>
          
          <Popconfirm
            title="¿Eliminar particular?"
            description="Esta acción no se puede deshacer"
            onConfirm={() => handleDelete(record.Codigo)}
            okText="Sí"
            cancelText="No"
            okButtonProps={{ danger: true }}
          >
            <Tooltip title="Eliminar">
              <Button
                danger
                icon={<DeleteOutlined />}
                size="small"
              />
            </Tooltip>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // Cargar datos iniciales
  useEffect(() => {    
    fetchTiposClientes();
    fetchParticulares();    
  }, []);

  const fetchTiposClientes = async () => {
    setLoadingTipos(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/tiposclientes`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Ordenar por descripción para mejor visualización
      const tiposOrdenados = (response.data.data || []).sort((a, b) => 
        a.Descripcion?.localeCompare(b.Descripcion || '')
      );
      
      setTiposClientes(tiposOrdenados);
      console.log(`✅ Tipos de clientes cargados: ${tiposOrdenados.length}`);
    } catch (error) {
      console.error('❌ Error cargando tipos de clientes:', error);
      message.warning('No se pudieron cargar los tipos de clientes');
      setTiposClientes([]);
    } finally {
      setLoadingTipos(false);
    }
  };

  // Función para obtener la descripción del tipo de cliente
  const getDescripcionTipoCliente = (codigoTipo) => {
    if (!codigoTipo) return 'Particular';
    
    const tipo = tiposClientes.find(t => t.Codigo === codigoTipo.toString());
    return tipo ? tipo.Descripcion : `Tipo ${codigoTipo}`;
  };

  // Función para obtener el color del tag según el tipo
  const getColorTipoCliente = (codigoTipo) => {
    const tipo = tiposClientes.find(t => t.Codigo === codigoTipo?.toString());
    
    if (!tipo) return 'default';
    
    // Asignar colores según el código o descripción
    switch (tipo.Codigo) {
      case '1': return 'blue';      // AGENCIA
      case '2': return 'green';     // PARTICULARS
      case '3': return 'orange';    // ESTUD.-DEPORT.
      case 'VIP': return 'gold';    // VIP (si existe)
      default: return 'cyan';       // Otros tipos
    }
  };  

  const fetchParticulares = async (params = {}) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      console.log(token);
      
      
      // Parámetros de la query
      const queryParams = {
        page: params.current || pagination.current,
        pageSize: params.pageSize || pagination.pageSize,
        search: searchText,
        sortField: params.sortField || sortedInfo.field || 'nombre',
        sortOrder: params.sortOrder || sortedInfo.order === 'ascend' ? 'ASC' : 'DESC'
      };
      
      // Añadir filtros
      if (filteredInfo.TipoCliente) {
        queryParams.TipoCliente = filteredInfo.TipoCliente[0];
      }
      if (filteredInfo.bloqueado) {
        queryParams.bloqueado = filteredInfo.bloqueado[0];
      }
      
      const response = await axios.get(`${BASE_URL}/api/particulares`, {
        headers: { Authorization: `Bearer ${token}` },
        params: queryParams
      });

      const cleanedData = (response.data.data || []).map(item => ({
        ...item,
        // Asegurar que los campos de texto no sean null
        Nombre: item.Nombre || '',
        nombre1: item.nombre1 || '',
        apellido1: item.apellido1 || '',
        apellido2: item.apellido2 || '',
        NIF: item.NIF || '',
        EMail: item.EMail || '',
        Telefono1: item.Telefono1 || '',
        Poblacion: item.Poblacion || '',
        Provincia: item.Provincia || '',
        Pais: item.Pais || '',
        TipoCliente: item.TipoCliente || '',
        // Asegurar que bloqueado sea booleano
        bloqueado: Boolean(item.bloqueado)
      }));      
      
      setParticulares(response.data.data);
      
      // Actualizar paginación
      setPagination({
        ...pagination,
        current: response.data.pagination.currentPage,
        pageSize: response.data.pagination.pageSize,
        total: response.data.pagination.totalRecords
      });

      const responsePaises = await axios.get(`${BASE_URL}/api/paises`, {
        headers: { Authorization: `Bearer ${token}` }
      });      

      setPaises(responsePaises.data.data)      
      
    } catch (error) {
      console.error('Error cargando particulares:', error);
      message.error('Error al cargar los particulares ');
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };


  const handleTableChange = (newPagination, filters, sorter) => {
    // Actualizar estados de filtros y ordenación
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    
    // Construir parámetros para la nueva carga
    const params = {
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      sortField: sorter.field,
      sortOrder: sorter.order === 'ascend' ? 'ASC' : 'DESC'
    };
    
    // Actualizar paginación
    setPagination(prev => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize
    }));
    
    // Cargar datos con nuevos parámetros
    fetchParticulares(params);
  };  

  const generarNombreCompleto = (nombre1, apellido1, apellido2) => {
    const partes = [];
    if (nombre1 && nombre1.trim()) partes.push(nombre1.trim());
    if (apellido1 && apellido1.trim()) partes.push(apellido1.trim());
    if (apellido2 && apellido2.trim()) partes.push(apellido2.trim());
    return partes.join(' ');
  };

  const fetchProximoCodigo = async () => {
    setLoadingCodigo(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/particulares/proximo-codigo`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      if (response.data.success) {
        setProximoCodigo(response.data.data.proximoCodigo);
        // Establecer el valor en el formulario
        form.setFieldsValue({ Codigo: response.data.data.proximoCodigo });
      }
    } catch (error) {
      console.error('❌ Error obteniendo próximo código:', error);
      // Generar código alternativo basado en timestamp
      const timestampCodigo = Math.floor(Date.now() / 1000).toString().slice(-6);
      setProximoCodigo(timestampCodigo);
      form.setFieldsValue({ Codigo: timestampCodigo });
    } finally {
      setLoadingCodigo(false);
    }
  };

  // Handlers para las acciones
  const handleCreate = async () => {
    setModalType('create');
    setCurrentParticular(null);
    form.resetFields();
    
    // Obtener próximo código antes de mostrar el modal
    await fetchProximoCodigo();
    
    // Establecer valores por defecto
    form.setFieldsValue({
      bloqueado: false,
      ListarDatos: true,
      MarcaMailing: false,
      Sexo: '1',
      TipoDocumento: '01',
      TipoCliente: '',
      Pais: 'ESP',
      // El código ya se estableció en fetchProximoCodigo
    });
    
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setModalType('edit');
    setCurrentParticular(record);
    
    // Obtener el próximo código también para edición
    fetchProximoCodigo();
    
    // Si no hay Nombre en el registro, generarlo
    let nombreCompleto = record.Nombre || '';
    if (!nombreCompleto && (record.nombre1 || record.apellido1 || record.apellido2)) {
      nombreCompleto = generarNombreCompleto(
        record.nombre1 || '',
        record.apellido1 || '',
        record.apellido2 || ''
      );
    }
    
    const formValues = {
      ...record,
      Nombre: nombreCompleto,
      nombre1: record.nombre1 || '',
      apellido1: record.apellido1 || '',
      apellido2: record.apellido2 || '',
      NIF: record.NIF || '',
      EMail: record.EMail || '',
      Telefono1: record.Telefono1 || '',
      Direccion: record.Direccion || '',
      Poblacion: record.Poblacion || '',
      Provincia: record.Provincia || '',
      Pais: record.Pais || '',
      CodPostal: record.CodPostal || '',
      LugarNacimiento: record.LugarNacimiento || '',
      notas: record.notas || '',
      TipoCliente: record.TipoCliente || '',
      FechaNacimiento: record.FechaNacimiento ? dayjs(record.FechaNacimiento) : null,
      FechaExpedicion: record.FechaExpedicion ? dayjs(record.FechaExpedicion) : null,
    };
    
    form.setFieldsValue(formValues);
    setModalVisible(true);
  };

  const handleView = (record) => {
    Modal.info({
      title: `Detalle de Particular: ${record.Nombre}`,
      width: 800,
      content: (
        <div style={{ marginTop: 20 }}>
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <strong>Código:</strong> {record.Codigo}
            </Col>
            <Col span={8}>
              <strong>Tipo Cliente:</strong> {record.TipoCliente || 'Particular'}
            </Col>
            <Col span={8}>
              <strong>Estado:</strong> {record.bloqueado ? 'Bloqueado' : 'Activo'}
            </Col>
            
            <Col span={12}>
              <strong>Nombre Completo:</strong> {record.Nombre}
            </Col>
            <Col span={12}>
              <strong>NIF:</strong> {record.NIF || 'No especificado'}
            </Col>
            
            <Col span={8}>
              <strong>Nombre:</strong> {record.nombre1}
            </Col>
            <Col span={8}>
              <strong>Apellido 1:</strong> {record.apellido1}
            </Col>
            <Col span={8}>
              <strong>Apellido 2:</strong> {record.apellido2}
            </Col>
            
            <Col span={8}>
              <strong>Sexo:</strong> {record.Sexo === '2' ? 'Femenino' : record.Sexo === '1' ? 'Masculino' : 'No especificado'}
            </Col>
            <Col span={8}>
              <strong>Fecha Nacimiento:</strong> {record.FechaNacimiento ? dayjs(record.FechaNacimiento).format('DD/MM/YYYY') : 'No especificada'}
            </Col>
            <Col span={8}>
              <strong>Lugar Nacimiento:</strong> {record.LugarNacimiento || 'No especificado'}
            </Col>
            
            <Col span={8}>
              <strong>Tipo Documento:</strong> {record.TipoDocumento || 'No especificado'}
            </Col>
            <Col span={8}>
              <strong>Fecha Expedición:</strong> {record.FechaExpedicion ? dayjs(record.FechaExpedicion).format('DD/MM/YYYY') : 'No especificada'}
            </Col>
            <Col span={8}>
              <strong>Teléfono:</strong> {record.Telefono1 || 'No especificado'}
            </Col>
            
            <Col span={12}>
              <strong>Email:</strong> {record.EMail || 'No especificado'}
            </Col>
            <Col span={12}>
              <strong>Dirección:</strong> {record.Direccion || 'No especificada'}
            </Col>
            
            <Col span={8}>
              <strong>Población:</strong> {record.Poblacion || 'No especificada'}
            </Col>
            <Col span={8}>
              <strong>Provincia:</strong> {record.Provincia || 'No especificada'}
            </Col>
            <Col span={8}>
              <strong>País:</strong> {record.Pais || 'No especificado'}
            </Col>
            
            <Col span={12}>
              <strong>Código Postal:</strong> {record.CodPostal || 'No especificado'}
            </Col>
            <Col span={12}>
              <strong>Campo Orden:</strong> {record.CampoOrden || '0'}
            </Col>
            
            <Col span={24}>
              <strong>Notas:</strong> {record.notas || 'Sin notas'}
            </Col>
          </Row>
        </div>
      ),
      onOk() {},
    });
  };

  const handleToggleBlock = async (record) => {
    try {
      const token = localStorage.getItem('token');
      const nuevoEstado = !record.bloqueado;
      
      await axios.patch(
        `${BASE_URL}/api/particulares/${record.Codigo}/estado`,
        { bloqueado: nuevoEstado },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Actualizar el estado local
      setParticulares(particulares.map(p => 
        p.Codigo === record.Codigo ? { ...p, bloqueado: nuevoEstado } : p
      ));
      
      message.success(`Particular ${nuevoEstado ? 'bloqueado' : 'desbloqueado'} correctamente`);
    } catch (error) {
      console.error('❌ Error cambiando estado:', error);
      message.error('Error al actualizar el estado');
    }
  };

  const handleDelete = async (codigo) => {
    try {
      const token = localStorage.getItem('token');
      await axios.delete(
        `${BASE_URL}/api/particulares/${codigo}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      // Filtrar el eliminado
      setParticulares(particulares.filter(p => p.Codigo !== codigo));
      
      // Actualizar total
      setPagination(prev => ({
        ...prev,
        total: prev.total - 1
      }));
      
      message.success('Particular eliminado correctamente');
    } catch (error) {
      console.error('❌ Error eliminando:', error);
      message.error(error.response?.data?.error || 'Error al eliminar el particular');
    }
  };

  // Handler para guardar (crear o editar)
  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const token = localStorage.getItem('token');

      if (!values.Nombre || values.Nombre.trim() === '') {
        values.Nombre = generarNombreCompleto(
          values.nombre1 || '',
          values.apellido1 || '',
          values.apellido2 || ''
        );
      }      
      
      // Formatear fechas
      if (values.FechaNacimiento) {
        values.FechaNacimiento = values.FechaNacimiento.format('YYYY-MM-DD');
      }
      if (values.FechaExpedicion) {
        values.FechaExpedicion = values.FechaExpedicion.format('YYYY-MM-DD');
      }
      
      if (modalType === 'create') {
        const response = await axios.post(
          `${BASE_URL}/api/particulares`,
          values,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        // setParticulares([...particulares, response.data]);
        fetchParticulares();
        message.success('Particular creado correctamente');
      } else {
        const response = await axios.put(
          `${BASE_URL}/api/particulares/${currentParticular.Codigo}`,
          values,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        setParticulares(particulares.map(particular => 
          particular.Codigo === currentParticular.Codigo ? response.data : particular
        ));
        message.success('Particular actualizado correctamente');
      }
      
      setModalVisible(false);
      form.resetFields();
    } catch (error) {
      message.error(error.response?.data?.error || 'Error al guardar los datos');
    }
  };

  // Handlers para filtros y ordenación
  const handleChange = (pagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };

  const clearFilters = () => {
    setFilteredInfo({});
    setSortedInfo({});
    setSearchText('');
  };

  // Funciones de búsqueda
  const getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reiniciar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : false,
  });

  const handleSearch = () => {
    if (searchText.trim() === '') {
        message.warning('Por favor ingrese un término de búsqueda');
        return;
    }    
    setSearchLoading(true);
    // Reiniciar a página 1 cuando se busca
    setPagination({ ...pagination, current: 1 });
    fetchParticulares({ current: 1 });
  };

  const handleResetSearch = () => {
    setSearchText('');
    setFilteredInfo({});
    setSortedInfo({});
    setSearchLoading(false);
    setPagination({ ...pagination, current: 1 });
    fetchParticulares({ current: 1 });
  };

  const searchBar = (
    <div style={{ marginBottom: 16 }}>
      <Space>
        <AntInput
          placeholder="Buscar por nombre, apellidos, NIF, email, teléfono..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 350 }}
          onPressEnter={handleSearch}
          allowClear
          onClear={handleResetSearch}
        />
        <Button
          type="primary"
          icon={<SearchOutlined />}
          onClick={handleSearch}
          loading={searchLoading}
        >
          Buscar
        </Button>
        <Button
          icon={<ReloadOutlined />}
          onClick={handleResetSearch}
        >
          Restablecer
        </Button>
        <span style={{ color: '#666', fontSize: '12px' }}>
          {pagination.total.toLocaleString()} registros
        </span>
      </Space>
    </div>
  );

  // Añadir propiedades de búsqueda a algunas columnas
  const columnsWithSearch = columns.map(col => {
    if (col.dataIndex === 'Nombre' || col.dataIndex === 'Codigo' || col.dataIndex === 'NIF') {
      return {
        ...col,
        ...getColumnSearchProps(col.dataIndex),
      };
    }
    return col;
  });

  // Función para exportar (placeholder)
  const handleExport = () => {
    message.info('Función de exportación en desarrollo');
  };

  // Estadísticas
  const estadisticas = (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
      <Col span={6}>
        <Statistic 
          title="Total Particulares" 
          value={pagination.total}
          prefix={<UserOutlined />}
          valueStyle={{ color: '#1890ff' }}
        />
      </Col>
      <Col span={6}>
        <Statistic 
          title="En esta página" 
          value={particulares.length}
          valueStyle={{ color: '#52c41a' }}
        />
      </Col>
      <Col span={6}>
        <Statistic 
          title="Página" 
          value={pagination.current}
          suffix={`/ ${Math.ceil(pagination.total / pagination.pageSize)}`}
          valueStyle={{ color: '#faad14' }}
        />
      </Col>
      <Col span={6}>
        <Statistic 
          title="Por página" 
          value={pagination.pageSize}
          valueStyle={{ color: '#722ed1' }}
        />
      </Col>
    </Row>
  );

  return (
    <>
      <PageContainer
        title="Particulares"
        subtitle={`${pagination.total.toLocaleString()} particulares registrados`}
        icon={<UserOutlined />}
        loading={loading}
        onRefresh={() => fetchParticulares()}
        onCreate={handleCreate}
        badgeCount={pagination.total}
        badgeStatus="processing"
        extra={
          <Space>
            <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
              <strong>{pagination.total.toLocaleString()}</strong> registros
            </Tag>
          </Space>
        }
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)'
        }}
      >
        {/* Estadísticas */}
        {estadisticas}
        
        {/* Barra de búsqueda */}
        {searchBar}
        
        {/* Tabla */}
        <Table
          columns={columns}
          dataSource={particulares}
          rowKey="Codigo"
          loading={loading}
          onChange={handleTableChange}
          pagination={pagination}
          scroll={{ x: 1300, y: 600 }}
          style={{
            borderRadius: '8px',
            overflow: 'hidden'
          }}
          size="middle"
          locale={{
            emptyText: 'No se encontraron particulares'
          }}          
        />
      </PageContainer>

      {/* Modal para crear/editar particular */}
      <Modal
        title={modalType === 'create' ? 'Nuevo Particular' : 'Editar Particular'}
        open={modalVisible}
        onOk={handleSave}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
        }}
        width={800}
        okText={modalType === 'create' ? 'Crear' : 'Guardar'}
        cancelText="Cancelar"
        confirmLoading={loading}
        style={{ top: 0 }}
        bodyStyle={{ maxHeight: 'calc(100vh - 108px)', overflowY: 'auto' }}        
      >
        <Form
          form={form}
          layout="vertical"
          onValuesChange={(changedValues, allValues) => {
            // Si cambian nombre1, apellido1 o apellido2, actualizar Nombre automáticamente
            if (changedValues.nombre1 !== undefined || 
                changedValues.apellido1 !== undefined || 
                changedValues.apellido2 !== undefined) {
              
              const nombreCompleto = generarNombreCompleto(
                allValues.nombre1 || '',
                allValues.apellido1 || '',
                allValues.apellido2 || ''
              );
              
              // Actualizar el campo Nombre sin disparar validación
              form.setFieldsValue({ 
                Nombre: nombreCompleto 
              });
            }
          }}          
          initialValues={{
            bloqueado: false,
            ListarDatos: true,
            MarcaMailing: false,
            Sexo: '1',
            TipoDocumento: '01',
            TipoCliente: '',
            Pais: 'ESP',
          }}
        >
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="Codigo"
                label="Código"
                rules={[{ required: true, message: 'Código generado automáticamente' }]}
              >
                <Input 
                  placeholder="Código automático" 
                  disabled 
                  suffix={
                    loadingCodigo ? 
                      <Spin size="small" /> : 
                      <KeyOutlined style={{ color: '#1890ff' }} />
                  }
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="TipoCliente"
                label="Tipo Cliente"
              >
                <Select>
                  {/* <Option value="">Particular</Option>
                  <Option value="VIP">VIP</Option>
                  <Option value="GRU">GRUP</Option>
                  <Option value="IND">Individual</Option> */}
                  {tiposClientes.map(tipo => (
                    <Option key={tipo.Codigo} value={tipo.Codigo}>
                      {tipo.Descripcion}
                    </Option>
                  ))}                  
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="bloqueado"
                label="Bloqueado"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>

          <Title level={5} style={{ marginBottom: 16, marginTop: 16 }}>Datos Personales</Title>
          {/* <Alert
            message="El nombre completo se genera automáticamente al completar los campos de nombre y apellidos"
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          /> */}
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="Nombre"
                label="Nombre Completo (Generado automáticamente)"
                rules={[{ required: true, message: 'El nombre completo es requerido' }]}
              >
                <Input 
                  placeholder="Se genera automáticamente" 
                  disabled 
                  style={{ 
                    backgroundColor: '#fafafa',
                    color: '#666'
                  }}
                />
              </Form.Item>
            </Col>
          </Row>          
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="nombre1"
                label="Nombre"
                rules={[{ required: true, message: 'Por favor ingrese el nombre' }]}
              >
                <Input 
                  placeholder="Nombre" 
                  onChange={(e) => {
                    // También podemos manejar el cambio aquí para feedback inmediato
                    const nombre1 = e.target.value;
                    const apellido1 = form.getFieldValue('apellido1') || '';
                    const apellido2 = form.getFieldValue('apellido2') || '';
                    form.setFieldsValue({ 
                      Nombre: generarNombreCompleto(nombre1, apellido1, apellido2)
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="apellido1"
                label="Primer Apellido"
                rules={[{ required: true, message: 'Por favor ingrese el primer apellido' }]}
              >
                <Input 
                  placeholder="Primer apellido"
                  onChange={(e) => {
                    const nombre1 = form.getFieldValue('nombre1') || '';
                    const apellido1 = e.target.value;
                    const apellido2 = form.getFieldValue('apellido2') || '';
                    form.setFieldsValue({ 
                      Nombre: generarNombreCompleto(nombre1, apellido1, apellido2)
                    });
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="apellido2"
                label="Segundo Apellido"
              >
                <Input 
                  placeholder="Segundo apellido"
                  onChange={(e) => {
                    const nombre1 = form.getFieldValue('nombre1') || '';
                    const apellido1 = form.getFieldValue('apellido1') || '';
                    const apellido2 = e.target.value;
                    form.setFieldsValue({ 
                      Nombre: generarNombreCompleto(nombre1, apellido1, apellido2)
                    });
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="NIF"
                label="NIF/DNI"
              >
                <Input placeholder="NIF o DNI" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="Sexo"
                label="Sexo"
              >
                <Select>
                  <Option value="1">Masculino</Option>
                  <Option value="2">Femenino</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="FechaNacimiento"
                label="Fecha Nacimiento"
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="LugarNacimiento"
                label="Lugar Nacimiento"
              >
                <Input placeholder="Lugar de nacimiento" />
              </Form.Item>
            </Col>
          </Row>

          <Title level={5} style={{ marginBottom: 16, marginTop: 16 }}>Documentación</Title>
          
          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="TipoDocumento"
                label="Tipo Documento"
              >
                <Select>
                  <Option value="01">DNI</Option>
                  <Option value="02">Pasaporte</Option>
                  <Option value="03">NIE</Option>
                  <Option value="04">CIF</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="FechaExpedicion"
                label="Fecha Expedición"
              >
                <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="CampoOrden"
                label="Campo Orden"
              >
                <InputNumber style={{ width: '100%' }} min={0} />
              </Form.Item>
            </Col>
          </Row>

          <Title level={5} style={{ marginBottom: 16, marginTop: 16 }}>Contacto</Title>
          
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Telefono1"
                label="Teléfono"
              >
                <Input placeholder="Teléfono" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="EMail"
                label="Email"
                rules={[
                  { type: 'email', message: 'Email no válido' }
                ]}
              >
                <Input placeholder="email@ejemplo.com" />
              </Form.Item>
            </Col>
          </Row>

          <Title level={5} style={{ marginBottom: 16, marginTop: 16 }}>Dirección</Title>
          
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Direccion"
                label="Dirección"
              >
                <Input placeholder="Dirección" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Poblacion"
                label="Población"
              >
                <Input placeholder="Población" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="Provincia"
                label="Provincia"
              >
                <Input placeholder="Provincia" />
              </Form.Item>
            </Col>
            <Col span={8}>
              {/* <Form.Item
                name="Pais"
                label="País"
              >
                <Input placeholder="País" />
              </Form.Item> */}
              <Form.Item
                  name="PaisISO"
                  label="Pais"
                >
                  <Select
                    showSearch
                    placeholder="Seleccione pais"
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                      option.label.toLowerCase().includes(input.toLowerCase())
                    }
                  >
                    {paises.map(pais => (
                      <Option key={pais.Codigo} value={pais.Descripcion} label={pais.Descripcion}>
                        {renderFlag(pais.CodigoISO)}
                        {pais.Descripcion}
                      </Option>
                    ))}
                  </Select>
              </Form.Item>              
            </Col>
            <Col span={8}>
              <Form.Item
                name="CodPostal"
                label="Código Postal"
              >
                <Input placeholder="Código postal" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="notas"
                label="Notas"
              >
                <Input.TextArea rows={3} placeholder="Notas adicionales" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={8}>
              <Form.Item
                name="ListarDatos"
                label="Listar en Datos"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name="MarcaMailing"
                label="Marca Mailing"
                valuePropName="checked"
              >
                <Switch />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default Particulares;